class ProductShare extends HTMLElement {
  connectedCallback() {
    this.nativeBtn = this.querySelector('[data-native-share]');
    this.copyBtn = this.querySelector('[data-copy-link]');
    this.copyFeedback = this.querySelector('[data-copy-feedback]');
    this.copyIcon = this.querySelector('[data-copy-icon]');
    this.checkIcon = this.querySelector('[data-check-icon]');

    this.shareUrl = this.dataset.shareUrl || (typeof window !== 'undefined' ? window.location.href : '');
    this.shareTitle = this.dataset.shareTitle || (typeof document !== 'undefined' ? document.title : '');
    this.shareText = this.dataset.shareText || this.shareTitle;

    // Check Web Share API support (Mobile browsers & desktop Safari)
    if (this.nativeBtn) {
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        this.nativeBtn.classList.remove('hidden');
        this.nativeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const currentUrl = this.getCurrentShareUrl();
          navigator.share({
            title: this.shareTitle,
            text: this.shareText,
            url: currentUrl
          }).catch((err) => {
            if (err.name !== 'AbortError') {
              this.copyToClipboard();
            }
          });
        });
      } else {
        this.nativeBtn.classList.add('hidden');
      }
    }

    // Direct popup links with non-blocking fallback
    this.querySelectorAll('[data-share-popup]').forEach((link) => {
      link.addEventListener('click', (e) => {
        // Let user modifier clicks (Cmd, Ctrl, Shift) behave normally
        if (e.ctrlKey || e.metaKey || e.shiftKey) {
          return;
        }

        // On mobile / narrow screens, open directly via native link in app or new tab
        if (typeof window !== 'undefined' && window.innerWidth < 768) {
          return;
        }

        const href = link.getAttribute('href');
        if (!href) return;

        const width = 640;
        const height = 560;
        const screenX = window.screenX || window.screenLeft || 0;
        const screenY = window.screenY || window.screenTop || 0;
        const left = Math.max(0, Math.round((window.innerWidth - width) / 2 + screenX));
        const top = Math.max(0, Math.round((window.innerHeight - height) / 2 + screenY));

        try {
          const popup = window.open(
            href,
            '_blank',
            `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=no`
          );

          // Only prevent default if popup successfully opened without being blocked
          if (popup && !popup.closed && typeof popup.closed !== 'undefined') {
            e.preventDefault();
            popup.focus();
          }
          // If popup is blocked by browser, do NOT preventDefault!
          // The native <a target="_blank"> will navigate cleanly in a new tab.
        } catch {
          // If window.open throws (e.g. iframe sandbox restriction), allow default <a target="_blank">
        }
      });
    });

    // Copy to clipboard
    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.copyToClipboard();
      });
    }
  }

  getCurrentShareUrl() {
    if (this.shareUrl && !this.shareUrl.includes('preview_theme_id') && !this.shareUrl.includes('_fd=')) {
      return this.shareUrl;
    }
    if (typeof window !== 'undefined' && window.location) {
      // Return clean origin + path without internal preview query parameters
      return window.location.origin + window.location.pathname;
    }
    return this.shareUrl || '';
  }

  async copyToClipboard() {
    const url = this.getCurrentShareUrl();
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement('textarea');
        input.value = url;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      this.showCopiedState();
    } catch {
      window.prompt('Copy product link:', url);
    }
  }

  showCopiedState() {
    if (this.copyIcon && this.checkIcon) {
      this.copyIcon.classList.add('hidden');
      this.checkIcon.classList.remove('hidden');
    }
    if (this.copyFeedback) {
      this.copyFeedback.classList.remove('opacity-0', 'pointer-events-none');
      this.copyFeedback.classList.add('opacity-100');
    }
    clearTimeout(this._copiedTimeout);
    this._copiedTimeout = setTimeout(() => {
      if (this.copyIcon && this.checkIcon) {
        this.copyIcon.classList.remove('hidden');
        this.checkIcon.classList.add('hidden');
      }
      if (this.copyFeedback) {
        this.copyFeedback.classList.add('opacity-0', 'pointer-events-none');
        this.copyFeedback.classList.remove('opacity-100');
      }
    }, 2500);
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', ProductShare);
}
